import {register} from '../vendor/theme-scripts/theme-sections';
import popupVideoSection from '../features/popup-video';
import galleryZoomSection from '../features/gallery-zoom';

register('gallery', [galleryZoomSection, popupVideoSection]);
